<script>
    import { onMount } from 'svelte';
    import { fetchPilotosPeso, searchPilotosPeso, subscribeToPilotosPeso, unsubscribeFromPilotosPeso } from '../controllers/pilotoPesoController.js';

    let records = [];
    let loading = true;
    let error = null;
    let searchQuery = '';

    // Configuración de las columnas para la tabla
    let columns = [
        { label: 'Fecha', field: 'fecha', type: 'date' },
        { label: 'Nombre', field: 'nombre', type: 'text' },
        { label: 'Total Peso', field: 'total_peso', type: 'number' }
    ];

    async function loadData() {
        try {
            loading = true;
            records = await fetchPilotosPeso();
            error = null;
        } catch (e) {
            error = e.message;
        } finally {
            loading = false;
        }
    }

    async function handleSearch() {
        if (!searchQuery) {
            await loadData();
            return;
        }
        try {
            loading = true;
            records = await searchPilotosPeso(searchQuery);
            error = null;
        } catch (e) {
            error = e.message;
        } finally {
            loading = false;
        }
    }

    let subscription;
    onMount(async () => {
        await loadData();
        subscription = subscribeToPilotosPeso(() => {
            loadData();
        });
        return () => {
            if (subscription) {
                unsubscribeFromPilotosPeso(subscription);
            }
        };
    });
</script>

<div class="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded">
    <div class="rounded-t mb-0 px-4 py-3 border-0">
        <div class="flex flex-wrap items-center">
            <div class="relative w-full px-4 max-w-full flex-grow flex-1">
                <h3 class="font-semibold text-base text-blueGray-700">
                    Reporte de Pilotos de Peso
                </h3>
            </div>
            <div class="relative w-full px-4 max-w-full flex-grow flex-1 text-right">
                <div class="flex items-center space-x-2">
                    <input
                        type="text"
                        bind:value={searchQuery}
                        placeholder="Buscar piloto..."
                        class="px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                    <button
                        on:click={handleSearch}
                        class="bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500"
                    >
                        Buscar
                    </button>
                </div>
            </div>
        </div>
    </div>

    <div class="block w-full overflow-x-auto">
        {#if loading}
            <div class="text-center py-4">Cargando...</div>
        {:else if error}
            <div class="text-center py-4 text-red-500">{error}</div>
        {:else}
            <table class="items-center w-full bg-transparent border-collapse">
                <thead>
                    <tr>
                        {#each columns as column}
                            <th class="px-6 bg-blueGray-50 text-blueGray-500 align-middle border border-solid border-blueGray-100 py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left">
                                {column.label}
                            </th>
                        {/each}
                    </tr>
                </thead>
                <tbody>
                    {#each records as record}
                        <tr>
                            {#each columns as column}
                                <td class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4">
                                    {#if column.type === 'date'}
                                        {new Date(record[column.field]).toLocaleDateString()}
                                    {:else if column.type === 'number'}
                                        {record[column.field].toLocaleString()}
                                    {:else}
                                        {record[column.field]}
                                    {/if}
                                </td>
                            {/each}
                        </tr>
                    {/each}
                </tbody>
            </table>
        {/if}
    </div>
</div> 